var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row margin-top-4x" }, [
    _c(
      "div",
      { staticClass: "col-sm-8 col-sm-offset-2 margin-top-3x" },
      [
        _c("div", { staticClass: "text-right" }, [
          _c(
            "button",
            {
              directives: [
                {
                  name: "hasPermits",
                  rawName: "v-hasPermits:allow",
                  value: ["channel_update", "super_admin"],
                  expression: "['channel_update', 'super_admin']",
                  arg: "allow"
                }
              ],
              staticClass: "btn btn-default",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.openCreateModal.apply(null, arguments)
                }
              }
            },
            [_vm._v("\n        New Rate Limit\n      ")]
          )
        ]),
        _vm._v(" "),
        _vm.loading
          ? _c("div", { staticClass: "text-center margin-top-3x" }, [
              _c("i", { staticClass: "fa fa-spinner fa-spin fa-3x fa-fw" })
            ])
          : _vm.apiRateLimits.length
          ? _c("div", { staticClass: "table-responsive margin-top-3x" }, [
              _c("table", { staticClass: "table table-striped" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("API Route")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Max Requests")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Window (sec)")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Enabled")]),
                    _vm._v(" "),
                    _c("th", {
                      directives: [
                        {
                          name: "hasPermits",
                          rawName: "v-hasPermits:allow",
                          value: ["channel_update", "super_admin"],
                          expression: "['channel_update', 'super_admin']",
                          arg: "allow"
                        }
                      ]
                    }),
                    _vm._v(" "),
                    _c("th", {
                      directives: [
                        {
                          name: "hasPermits",
                          rawName: "v-hasPermits:allow",
                          value: ["channel_update", "super_admin"],
                          expression: "['channel_update', 'super_admin']",
                          arg: "allow"
                        }
                      ]
                    })
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.apiRateLimits, function(item) {
                    return _c("tr", { key: item.id }, [
                      _c("td", [_vm._v(_vm._s(item.route))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.max_requests))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm.formatWindow(item.window_seconds)))
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "span",
                          {
                            class: item.is_enabled
                              ? "text-success"
                              : "text-muted"
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(item.is_enabled ? "Yes" : "No") +
                                "\n              "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          directives: [
                            {
                              name: "hasPermits",
                              rawName: "v-hasPermits:allow",
                              value: ["channel_update", "super_admin"],
                              expression: "['channel_update', 'super_admin']",
                              arg: "allow"
                            }
                          ]
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "text-info",
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.openEditModal(item)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-pencil" })]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          directives: [
                            {
                              name: "hasPermits",
                              rawName: "v-hasPermits:allow",
                              value: ["channel_update", "super_admin"],
                              expression: "['channel_update', 'super_admin']",
                              arg: "allow"
                            }
                          ]
                        },
                        [
                          _vm.deleteLoadings[item.id]
                            ? _c("span", [
                                _c("i", {
                                  staticClass: "fa fa-spinner fa-spin"
                                })
                              ])
                            : _c(
                                "a",
                                {
                                  staticClass: "text-danger",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.removeItem(item)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-trash" })]
                              )
                        ]
                      )
                    ])
                  }),
                  0
                )
              ])
            ])
          : _c("div", { staticClass: "text-warning margin-top-3x" }, [
              _vm._v(
                "\n      There are no API rate limits for this channel\n    "
              )
            ]),
        _vm._v(" "),
        _c("form-modal", {
          ref: "formModal",
          on: { saved: _vm.getApiRateLimits }
        }),
        _vm._v(" "),
        _c("confirm", { ref: "confirmDelete", attrs: { type: "danger" } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f643b634", { render: render, staticRenderFns: staticRenderFns })
  }
}